
import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    setIsSubmitting(true);
    
    try {
      const formData = new FormData();
      formData.append('email', email);
      
      const response = await fetch('https://readdy.ai/api/form/d47tjmahchb23d4eftc0', {
        method: 'POST',
        body: new URLSearchParams(formData as any)
      });
      
      if (response.ok) {
        setIsSubmitted(true);
        setEmail('');
      }
    } catch (error) {
      console.error('구독 신청 중 오류가 발생했습니다:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-20 bg-teal-600">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-bold text-white mb-4">
          마케팅 인사이트를 받아보세요
        </h2>
        <p className="text-xl text-teal-100 mb-8">
          최신 마케팅 트렌드와 퍼널 최적화 팁을 매주 이메일로 받아보세요
        </p>
        
        {isSubmitted ? (
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
            <i className="ri-check-line text-4xl text-white mb-4 block"></i>
            <h3 className="text-xl font-semibold text-white mb-2">구독 완료!</h3>
            <p className="text-teal-100">
              곧 유용한 마케팅 인사이트를 받아보실 수 있습니다.
            </p>
          </div>
        ) : (
          <form 
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto"
            data-readdy-form
            id="newsletter-form"
          >
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="이메일 주소를 입력하세요"
              className="flex-1 px-4 py-3 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-white"
              required
            />
            <button
              type="submit"
              disabled={isSubmitting}
              className="bg-white text-teal-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors disabled:opacity-50 whitespace-nowrap cursor-pointer"
            >
              {isSubmitting ? '구독 중...' : '구독하기'}
            </button>
          </form>
        )}
        
        <p className="text-sm text-teal-200 mt-4">
          언제든지 구독을 취소할 수 있습니다. 개인정보는 안전하게 보호됩니다.
        </p>
      </div>
    </section>
  );
}
